// extracted by mini-css-extract-plugin
export default {"main":"nbti9","icon":"fBGwc","text":"BHhrk","saleSoon":"ovyVE","zeroOffset":"o3nTo"};